import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApi } from "../../../api";
import { Numeral } from "../../../components/Numeral";
import { useProjectCode } from "../../../hooks/useProjectCode"
import { ICargo, IProduct } from "../../../interfaces";
import { Utils } from "../../../utils";

export const HomePage = () => {
  const projectCode = useProjectCode();
  const api = useApi(projectCode);
  const navigate = useNavigate();
  const [products, setProducts] = useState<IProduct[]>([]);

  useEffect(() => {
    api.getProducts(projectCode, (cargo: ICargo) => {
      setProducts(cargo.info);
    })
  }, [api, projectCode])

  return (
    <>
      <div>

        <div className="mx-auto max-w-2xl py-16 px-4 sm:py-24 sm:px-6 lg:max-w-7xl lg:px-8">
          <h2 className="sr-only">Products</h2>

          <div className="grid grid-cols-1 gap-y-10 gap-x-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8">

            {products.map((product: IProduct) => {
              return (
                <div key={product.idProduct} className="group cursor-pointer" onClick={() => {
                  navigate(`/store/${projectCode}/product/detail/${product.idProduct}`)
                }}>
                  <div className="aspect-w-1 aspect-h-1 w-full overflow-hidden rounded-lg bg-gray-200 xl:aspect-w-7 xl:aspect-h-8">
                    <img src={Utils().normalizeImagePath(product.cover, projectCode)} alt={product.description} className="h-full w-full object-cover object-center group-hover:opacity-75" />
                  </div>
                  <h3 className="mt-4 text-sm text-gray-700">{product.name}</h3>
                  <p className="mt-1 text-lg font-medium text-gray-900">$<Numeral value={product.price} /></p>
                </div>
              )
            })}

          </div>
        </div>
      </div>
    </>
  )
}